import { render, staticRenderFns } from "./vTextField.vue?vue&type=template&id=a99c5120"
import script from "./vTextField.vue?vue&type=script&lang=js"
export * from "./vTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports